export const BOOTSTRAP_COOKIE = '@@lib-cookie/BOOTSTRAP';
export const GET_COOKIE = '@@lib-cookie/GET';
export const REMOVE_COOKIE = '@@lib-cookie/REMOVE';
export const SET_COOKIE = '@@lib-cookie/SET';
export const DELETE_NON_ESSENTIAL_COOKIES = '@@lib-cookie/DELETE_NON_ESSENTIAL_COOKIES';
export const HAS_CONSENTED = 'hasConsented';
// F19001 :: 'wscrCookieConsent' is a new Cookie dropped by Digital Control Room  API
// Example value: 1=true&2=false&3=false&4=false&5=false&version=20200709-001
// Each number property references a Cookie category and the boolean value represents an opt-in/opt-out flag
export const WSCR_COOKIE_CONSENT = 'wscrCookieConsent';
export const OPTIMIZELY_END_USER_ID = 'optimizelyEndUserId';
/* eslint-disable sort-keys */
export const WSCR_COOKIE_CONSENT_CATEGORIES = {
    STRICTLY_NECESSARY: [
        '__cf_bm',
        '__cfduid',
        '__cfruid',
        '_did',
        'activity',
        'alwaysRemember',
        'ermEnabled',
        HAS_CONSENTED,
        'iframe',
        'parentUrl',
        'ready',
        'remember_me',
        'remember_me_code',
        'remember_me_code_vdcp',
        'secured_id_token',
        'ssiDeclined',
        'ssiEnabled',
        'thx_guid',
        'visited',
        WSCR_COOKIE_CONSENT,
        'x-via-hint',
        'x-via-hint_dca'
    ],
    SITE_EXPERIENCE: ['_art', 'country_preference', 'locale'],
    PERFORMANCE_AND_OPERATION: [
        '_ga',
        '_gid',
        OPTIMIZELY_END_USER_ID,
        'VCO_apikey',
        'VCO_visitId',
        'VCO_correlationId'
    ],
    MARKETING_PERSONALIZATION_AND_ADVERTISING: ['_gcl_au', 'campaign_tracking'],
    VISA_COOKIE_NOTICE: []
};
export const WSCR_COOKIE_CONSENT_PROPS = {
    STRICTLY_NECESSARY: '1',
    SITE_EXPERIENCE: '2',
    PERFORMANCE_AND_OPERATION: '3',
    MARKETING_PERSONALIZATION_AND_ADVERTISING: '4',
    VISA_COOKIE_NOTICE: '5',
    VERSION: 'version'
};
//# sourceMappingURL=index.js.map